import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JSONSchemaForm from 'react-jsonschema-form';
import { isEqual } from 'lodash';

import { TextInput } from '@components/common';
import DropDown from './dropDown';

class Form extends Component {
	componentDidMount() {
		const { setRefValue } = this.props;
		if (setRefValue) setRefValue(this.formRef);
	}

	shouldComponentUpdate = ({
		liveValidate, buttonState, formSchema, formData,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(liveValidate, lastProps.liveValidate)
			|| !isEqual(buttonState, lastProps.buttonState)
			|| !isEqual(formSchema, lastProps.formSchema)
			|| !isEqual(formData, lastProps.formData)
		);
	}

	render() {
		const {
			formSchema,
			widgets,
			showErrorList,
			formData,
			liveValidate,
			children,
			onChange,
			onBlur,
			onSubmit,
			onError,
			validate,
			keyName,
		} = this.props;

		return (
			<JSONSchemaForm
				{...formSchema /* eslint-disable-line react/jsx-props-no-spreading */}
				key={keyName}
				formData={formData}
				widgets={widgets}
				onChange={onChange}
				onSubmit={onSubmit}
				onError={onError}
				onBlur={onBlur}
				liveValidate={liveValidate}
				showErrorList={showErrorList}
				validate={validate}
				FieldTemplate={({ children : field }) => (field)}
				ref={(form) => { this.formRef = form; }}
			>
				{ children }
			</JSONSchemaForm>
		);
	}
}

Form.propTypes = {
	keyName       : PropTypes.string.isRequired,
	formData      : PropTypes.object.isRequired,
	onChange      : PropTypes.func.isRequired,
	onSubmit      : PropTypes.func.isRequired,
	widgets       : PropTypes.object,
	showErrorList : PropTypes.bool,
	liveValidate  : PropTypes.bool,
	onError       : PropTypes.func,
	setRefValue   : PropTypes.func,
	buttonState   : PropTypes.string,
	onBlur        : PropTypes.func,
	validate      : PropTypes.func,
	children      : PropTypes.any,
	formSchema    : PropTypes.shape({
		schema   : PropTypes.object.isRequired,
		uiSchema : PropTypes.object.isRequired,
	}).isRequired,
};

Form.defaultProps = {
	showErrorList : false,
	liveValidate  : false,
	buttonState   : '',
	setRefValue   : () => {},
	onError       : undefined,
	onBlur        : undefined,
	validate      : undefined,
	children      : null,
	widgets       : {
		textInput : TextInput,
		dropDown  : DropDown,
	},
};

export default Form;
